/** 가상머니/점수 표시용 천단위 콤마 포매터. */
export function fmt(n: number): string {
  const sign = n < 0 ? '-' : '';
  return sign + Math.abs(Math.round(n)).toLocaleString('ko-KR');
}

/** 부호를 항상 보이는 포맷(+/-). */
export function fmtSigned(n: number): string {
  return (n > 0 ? '+' : n < 0 ? '-' : '') + Math.abs(Math.round(n)).toLocaleString('ko-KR');
}
